/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_Faq_2_QInputs */

const en_vc_onl_faq_2_q = /** @type {(inputs: Vc_Onl_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are my files uploaded anywhere?`)
};

const zh_vc_onl_faq_2_q = /** @type {(inputs: Vc_Onl_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的文件会被上传吗？`)
};

/**
* | output |
* | --- |
* | "Are my files uploaded anywhere?" |
*
* @param {Vc_Onl_Faq_2_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_faq_2_q = /** @type {((inputs?: Vc_Onl_Faq_2_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_Faq_2_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_faq_2_q(inputs)
	return zh_vc_onl_faq_2_q(inputs)
});
export { vc_onl_faq_2_q as "vc.onl.faq.2.q" }